import { defineMessages } from 'react-intl'

const AST1 = 'AST1'
const AST1Refresher = 'AST1Refresher'
const AST1plus = 'AST1+'
const AST1plus2 = 'AST1+2'
const AST2 = 'AST2'
const CRS = 'CRS'
const MAT = 'MAT'

export const LEVELS = [AST1, AST1Refresher, AST1plus, AST1plus2, AST2, CRS, MAT]

export const LevelMessages = defineMessages({
    [AST1]: {
        defaultMessage: 'AST 1',
        description: 'Constants layouts/ast',
    },
    [AST1Refresher]: {
        defaultMessage: 'AST 1 Refresher',
        description: 'Constants layouts/ast',
    },
    [AST1plus]: {
        defaultMessage: 'AST 1 + MAT',
        description: 'Constants layouts/ast',
    },
    [AST1plus2]: {
        defaultMessage: 'AST 1 + AST 2 Combined',
        description: 'Constants layouts/ast',
    },
    [AST2]: {
        defaultMessage: 'AST 2',
        description: 'Constants layouts/ast',
    },
    [CRS]: {
        defaultMessage: 'Companion Rescue (CRS)',
        description: 'Constants layouts/ast',
    },
    [MAT]: {
        defaultMessage: 'Managing Avalanche Terrain (MAT)',
        description: 'Constants layouts/ast',
    },
})

export const TagMessages = defineMessages({
    SKI: {
        defaultMessage: 'Ski',
        description: 'Constants layouts/ast',
    },
    SLED: {
        defaultMessage: 'Sled',
        description: 'Constants layouts/ast',
    },
    SNOWSHOE: {
        defaultMessage: 'Snowshoe',
        description: 'Constants layouts/ast',
    },
    YOUTH: {
        defaultMessage: 'Youth',
        description: 'Constants layouts/ast',
    },
})

export const MINIMUM_DISTANCE = 10
